// @ts-nocheck

import { BasketStatuses } from '../../../types/basket';

const basketSelectedBonusChange = (state, action) => {
  const { status, selectedBonusId, selectedFreebetId } = state;
  const { promotionId } = action.payload;
  if (status !== BasketStatuses.PENDING && status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) {
    if (promotionId !== selectedBonusId) {
      return {
        ...state,
        selectedBonusId: promotionId,
        selectedFreebetId: selectedFreebetId === true ? undefined : selectedFreebetId,
      };
    }
  }
  return state;
};

export default basketSelectedBonusChange;
